module.exports = __webpack_public_path__ + "img/special-liu-icon.acc1d667.png";